var render = function render(){var _vm=this,_c=_vm._self._c;return _c('butn',{attrs:{"btntype":"primary","title":_vm.btnDisable ? `刷新(${this.countDown}s)` : '刷新',"disabled":_vm.btnDisable},nativeOn:{"click":function($event){return _vm.refresh.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }